import { VStack } from 'ui_2';
import {
  LeaderboardDurationTabs,
  LeaderboardTypeTabs,
} from './LeaderboardTabs';
import { Leaderboard } from './Leaderboard';
import { LeaderboardInfoBanner } from './LeaderboardInfo';
import { useLeaderboard } from '@src/hooks/useQuests';
import { useState } from 'react';
import { LeaderboardDuration, LeaderboardType } from 'jigsaw';

export const LeaderboardPageContents = () => {
  const [duration, setDuration] = useState<LeaderboardDuration>(
    LeaderboardDuration.Day
  );
  const [leaderboardType, setLeaderboardType] = useState<LeaderboardType>(
    LeaderboardType.PARC
  );

  const { data: leaderboardData, isLoading } = useLeaderboard({
    duration,
    leaderboardType,
  });

  // Find current user entry
  const userEntry = leaderboardData?.userEntry;

  return (
    <VStack className='w-full max-w-[500px] justify-center gap-4'>
      <LeaderboardTypeTabs
        value={leaderboardType}
        onChange={setLeaderboardType}
      />
      {leaderboardData !== null && (
        <LeaderboardInfoBanner
          leaderboard={leaderboardData}
          isLoading={isLoading}
        />
      )}
      <LeaderboardDurationTabs value={duration} onChange={setDuration} />
      <Leaderboard
        entries={leaderboardData?.entries ?? []}
        isLoading={isLoading}
        userEntry={userEntry}
        reward={leaderboardData?.reward}
      />
    </VStack>
  );
};
